import {
	Box,
	Button,
	FormControl,
	Grid,
	InputLabel,
	MenuItem,
	Select,
	TextField,
	Typography,
} from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";

import SearchIcon from "@mui/icons-material/Search";
import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getDataSources, getScenario, setState, getCustGrpRef, reset, getCustomerCountries } from "./editScenarioNewSlice";
import { sizes } from "./editScenarioNewUtils";
import CustomButton from "../../../components/ui/CustomButton";

export default function SearchScenario() {
	const dispatch = useDispatch();
	const setupState = useSelector((store) => store.editScenarioNew);
	const loginState = useSelector((store) => store.login);
	const { countries,navigated_ScenarioName, selectedCountry, countryID, scenarioName, predictionMethodPeriodList, previousYearPeriodList,DefaultInitialForecast } = setupState;
	const { globalSelectedCountryName,globalSelectedCountryID,} = loginState
	//const [minSelectableDate, setminFromDate] = useState(dayjs().startOf("month").toDate());
	//console.log(dayjs().startOf("month").toDate())
	const timeStamp = "2099-12-31 00:00";
	console.log(timeStamp)
	console.log(dayjs())
	const [fromDate, setFromDate] =  useState(null);
	const [toDate, setToDate] = useState(null);
	const [scenario_Name, setScenarioName] = useState("");

	useEffect(() => {
		if(globalSelectedCountryID !== null){
		if(countryID !== globalSelectedCountryID){
			dispatch(reset("refresh"));
		}
		dispatch(setState("countryID", globalSelectedCountryID));
		}
	},[globalSelectedCountryID])

	useEffect(()=>{
		if(navigated_ScenarioName !=="" && navigated_ScenarioName !== null && navigated_ScenarioName !== undefined){
			setScenarioName(navigated_ScenarioName);
		}
	},[navigated_ScenarioName])

	useEffect(() => {
		if(globalSelectedCountryName !== null && globalSelectedCountryName !== ""){
		dispatch(setState("selectedCountry", globalSelectedCountryName));
		}
	},[globalSelectedCountryName])

	const handleCountryChange = (event) => {
		dispatch(reset("refresh"));
		const countryName = event.target.value;
		const countryId = countries.find(
			(country) => country.countryName === countryName
		).countryID;
		console.log(countryId, countryName);
		dispatch(setState("selectedCountry", countryName));
		dispatch(setState("countryID", countryId));

		clearCountryDependents();
		getCountryDependents(countryId);
	};

	const clearCountryDependents = () => {
		dispatch(setState("dataSources", []));
		dispatch(setState("selectedDSs", []));
		dispatch(setState("customerCountries", []));
		dispatch(setState("selCustCountries", []));		
	};

	const getCountryDependents = (countryID) => {
		dispatch(getDataSources({ countryID }));
		dispatch(getCustGrpRef({countryID})).then((res) => {
			let { customerLevels, customerTypes } = res.payload;
			let firstType = null,
				level = null;
			if (customerTypes && customerTypes.length > 0) {
				firstType = customerTypes[0];
			}
			if (customerLevels && customerLevels.length > 0) {
				level = customerLevels.find(
					(custLevel) => custLevel.customerLevelID === "SH"
				);
			}
			dispatch(
				getCustomerCountries({
					CountryId: countryID,
					Level: level.customerLevelID,
					//Type: firstType.customerTypeCode,
					Type: "All",
				})
			);
		});
	};

	const handleFromDate = (newValue) => {
		console.log("Edit_SearchScenario", newValue);
		//if (newValue <= toDate) {
			setFromDate(newValue);
		//}
	};

	const handleToDate = (newValue) => {
		console.log("Edit_SearchScenario", newValue);
		//if (newValue >= fromDate) {
			setToDate(newValue);
		//}
	};

	const changeDateFormat = (date) => {
		const year = date.year();
		const month =
			date.month() + 1 < 10 ? `0${date.month() + 1}` : date.month() + 1;
		const day = date.date() < 10 ? `0${date.date()}` : date.date();
		const time = "T00:00:00.000Z";
		const d = `${year}-${month}-${day}${time}`;
		return d;
	};
	const showMessage = (message, severity) => {
		dispatch(setState("message", message));
		dispatch(setState("severity", severity));
		dispatch(setState("messageOpen", true));
	};

	const handleSearch = () => {
		dispatch(reset("selectScenario"));
		if(countryID == undefined ||countryID ==null || countryID == "") {
			showMessage("Please select country" , "info");
			return;
		}
		if(fromDate > toDate && toDate != null && fromDate != null) {
			showMessage("From Date cannot be greater than To Date" , "info");
			return;
		}
		dispatch(setState("editScenarioList", []));
		dispatch(setState("editScName", ""));
		dispatch(setState("editScID", ""));
		const fdate = "";
		const tdate = "";
		const obj = {
			countryId: countryID,
			scenario: scenario_Name,
			fromDate: fromDate == null ? fdate : changeDateFormat(fromDate),
			toDate: toDate == null ? tdate : changeDateFormat(toDate)
		};
		console.log("SearchScenario", obj);
		dispatch(getScenario(obj));
	};

	const searchScenarioName=(event)=>{
		let name = event.target.value;
	  
		// Remove special characters
		name = name.replace(/[^a-zA-Z0-9 ]/g, "");
	  
		//Replace multiple consecutive spaces with a single space
		name = name.replace(/\s{2,}/g, " ");
	  
		// Trim leading space
		name = name.trimStart();
	  
		//Dispatch cleaned value
		setScenarioName(name);
	}

	return (
		<Box >
			<Grid container columns={12} justifyContent="space-between" alignItems="center" spacing={2} pb={1}
			//  maxWidth={"99%"}
			 >
				<Grid item xs={12} sm={6} md={6} lg={6}>
					<Box >
						<FormControl sx={{
									mt: 2,
									width: '100%',
								}}>
							<InputLabel 
							id="demo-simple-select-label">
								Country
							</InputLabel>
							<Select 
								labelId="demo-simple-select-label"
								id="demo-simple-select"
								value={selectedCountry}
								label="Country"
								onChange={handleCountryChange}>
								{countries.map((country, index) => {
									return (
										<MenuItem value={country.countryName} key={index}>
											{country.countryName}
										</MenuItem>
									);
								})}
							</Select>
						</FormControl>
					</Box>
				</Grid>

				<Grid item xs={12} sm={6} md={6} lg={6}>
					<Box >
					<TextField sx={{ mt:2, width: '100%',}}
						id="outlined-basic"
						label="Scenario Name"
						variant="outlined"
						value={scenario_Name}
						onChange={(event) =>{
							searchScenarioName(event);}
						}
						InputProps={{ autoComplete: "off" }}
					/>
					</Box>
				</Grid>

				<Grid item xs={12} sm={6} md={6} lg={6}>
					<Box
						sx={{
							mt: 1,
							width: '100%'
						}}
					>
						<LocalizationProvider dateAdapter={AdapterDayjs}>
							<DatePicker sx={{
							mt: 1,
							width: '100%'
						}}
								// minDate={minSelectableDate}
								label="From"
								value={fromDate}
								onChange={(newValue) => handleFromDate(newValue)}
								format="DD/MM/YYYY"
								renderInput={(params) => (
									<TextField 
										{...params}
										size="small"/>
								)}
							/>
						</LocalizationProvider>
					</Box>
				</Grid>
				<Grid item xs={12} sm={6} md={6} lg={6}>
					<Box
						sx={{
							mt: 1,
						}}
					>
						<LocalizationProvider dateAdapter={AdapterDayjs}>
							<DatePicker sx={{
							mt: 1,
							width: '100%'
						}}
								// minDate={minSelectableDate}
								label="To"
								value={toDate}
								onChange={(newValue) => handleToDate(newValue)}
								format="DD/MM/YYYY"
								renderInput={(params) => (
									<TextField
										{...params}
										size="small"
										sx={{ height: sizes.h35,width: sizes.w200 }}
									/>
								)}
							/>
						</LocalizationProvider>
					</Box>
				</Grid>
			</Grid>
			<Grid sx={{display: "flex",
							justifyContent: "flex-end",
							alignItems: "right",}}>
				<Box>
					<CustomButton
						startIcon={<SearchIcon sx={{ minWidth: 1,}}/>}
						// sx={{
						// 	bgcolor: "darkred.light",
						// 	color: "white.main",
						// 	textTransform: "none",
						// 	mt: 2,
						// 	"&:hover": {
						// 		bgcolor: "darkred.main",
						// 	},
						// }}
						onClick={handleSearch}
					>
						{/* <Typography
							sx={{ variant: "button1", color: "white.main", fontWeight: 500, }}
						> */}
							Search
						{/* </Typography> */}
					</CustomButton>
				</Box>
			</Grid>
		</Box>
	);
}
